import { OrderCardAppliance } from "./orderCardAppliance";
import { OrderCardBusinessBuyer } from "./orderCardBusinessBuyer";
import {
  OrderCardBusinessHome,
  OrderCardModelError,
} from "./orderCardBusinessHome";
import { OrderCardBusinessLogistics } from "./orderCardBusinessLogistics";
import {
  OrderCardCustomSubgroup,
  OrderCardInvalidGroupError,
  OrderCardInvalidRoomsError,
} from "./orderCardCustomSubgroup";
import {
  OrderCardConstructionCustomSubgroup,
} from "./orderCardConstructionCustomSubgroup";
import {
  OrderCardFinancialFees,
  OrderCardFinancialFeesFreightError,
  OrderCardFinancialFeesSalesAllowanceError,
} from "./orderCardFinancialFees";
import { OrderCardRetailerFees } from "./orderCardRetailerFees";
import {
  OrderCardFinancialFinancing,
  OrderCardFinancialFinancingInvalidVendor,
} from "./orderCardFinancialFinancing";
import { OrderCardFinancialPricing } from "./orderCardFinancialPricing";
import { OrderCardHeatUValues } from "./orderCardHeatUValues";
import { OrderCardInvoiceCeilingInsulation } from "./orderCardInvoiceCeilingInsulation";
import { OrderCardInvoiceDates } from "./orderCardInvoiceDates";
import { OrderCardInvoiceSection } from "./orderCardInvoiceSection";
import { OrderCardInvoiceSpecifications } from "./orderCardInvoiceSpecifications";
import { OrderCardInvoiceHeatingCoolingDucts } from "./orderCardInvoiceHeatingCoolingDucts";
import { OrderCardInvoiceExteriorWallInsulation } from "./orderCardInvoiceExteriorWallInsulation";
import { OrderCardInvoiceFloorInsulation } from "./orderCardInvoiceFloorInsulation";
import {
  OrderCardSOAttributeExpired,
  OrderCardSOAttributeRemoved,
  OrderCardSOInvalidOption,
  OrderCardSOInvalidRooms,
  OrderCardSOInvalidSubgroupError,
  OrderCardSubgroupOption,
  OrderCardSubgroupOptionInvalidSeriesError,
  OrderCardSOMinQuantity,
  OrderCardSOMaxQuantity,
} from "./orderCardSubgroupOption";
import { OrderCardApplianceVendorError } from "./orderCardAppliance";
import { OrderCardAddAppliance } from "./orderCardAddAppliance";
import {
  OrderCardChangeOrderInvalidRoomsError,
  OrderCardChangeOrderDuplicateError,
  OrderCardSalesChangeOrder,
} from "./orderCardSalesChangeOrder";
import { OrderCardAddSalesChangeOrder } from "./orderCardAddSalesChangeOrder";
import { OrderCardAdditionalBuyerQuestions } from "./orderCardAdditionalBuyerQuestions";
import { OrderCardConstructionOption } from "./orderCardConstructionOption";
import { OrderCardConstructionHiddenOption } from "./orderCardConstructionHiddenOption";

export type OrderCard =
  | OrderCardBusinessLogistics
  | OrderCardBusinessBuyer
  | OrderCardBusinessHome
  | OrderCardFinancialFinancing
  | OrderCardFinancialFees
  | OrderCardFinancialPricing
  | OrderCardSubgroupOption
  | OrderCardCustomSubgroup
  | OrderCardConstructionCustomSubgroup
  | OrderCardInvoiceDates
  | OrderCardInvoiceSection
  | OrderCardHeatUValues
  | OrderCardAppliance
  | OrderCardInvoiceSpecifications
  | OrderCardInvoiceHeatingCoolingDucts
  | OrderCardInvoiceFloorInsulation
  | OrderCardInvoiceExteriorWallInsulation
  | OrderCardInvoiceCeilingInsulation
  | OrderCardSalesChangeOrder
  | OrderCardAddAppliance
  | OrderCardAddSalesChangeOrder
  | OrderCardAdditionalBuyerQuestions
  | OrderCardRetailerFees
  | OrderCardConstructionOption
  | OrderCardConstructionHiddenOption;

type OrderCardErrorCode =
  | "eblr"
  | "eblv"
  | "ebhm"
  | "ecsg"
  | "ecsr"
  | "esog"
  | "esos"
  | "esoo"
  | "esoar"
  | "esoae"
  | "esor"
  | "eiav"
  | "ecor"
  | "ecod"
  | "esoos"
  | "esmq"
  | "esxq"
  | "effv"
  | "efef"
  | "efesa"
  | null;

export type OrderCardError<T = any> = {
  type: string;
  data: T;
};

export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "eblr"
): null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "eblv"
): null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "ebhm"
): OrderCardModelError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "ecsg"
): OrderCardInvalidGroupError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "ecsr"
): OrderCardInvalidRoomsError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esog"
): OrderCardInvalidGroupError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esos"
): OrderCardSOInvalidSubgroupError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esoo"
): OrderCardSOInvalidOption["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esoar"
): OrderCardSOAttributeRemoved["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esoae"
): OrderCardSOAttributeExpired["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esor"
): OrderCardSOInvalidRooms["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "eiav"
): OrderCardApplianceVendorError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "ecor"
): OrderCardChangeOrderInvalidRoomsError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "ecod"
): OrderCardChangeOrderDuplicateError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esoos"
): OrderCardSubgroupOptionInvalidSeriesError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esmq"
): OrderCardSOMinQuantity["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "esxq"
): OrderCardSOMaxQuantity["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "effv"
): OrderCardFinancialFinancingInvalidVendor["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "efef"
): OrderCardFinancialFeesFreightError["data"] | null;
export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: "efesa"
): OrderCardFinancialFeesSalesAllowanceError["data"] | null;
export function getOrderCardError(orderCard: OrderCard, errorCode: null): null;

export function getOrderCardError(
  orderCard: OrderCard,
  errorCode: OrderCardErrorCode
): OrderCardError["data"] | null {
  return (
    orderCard.errors.find((error) => error.type === errorCode)?.data ?? null
  );
}

// Iterative comparison
// Note that we iterate over the keys found in the primary OrderCard so if secondary
// has extra keys, they will be ignored
export const deepEqual = (obj1: any, obj2: any): boolean => {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return obj1 === obj2;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every((key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key]));
}